<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card elevation="0">
          <v-row>
            <v-col>
              <v-btn class="ma-1" elevation="0" @click="selectedProgrammingLanguage = 'curl'" v-bind:color="selectedProgrammingLanguage === 'curl' ? '#bbdefb' : '#ffffff'">cURL</v-btn>
              <v-btn class="ma-1" elevation="0" @click="selectedProgrammingLanguage = 'javascript'" v-bind:color="selectedProgrammingLanguage === 'javascript' ? '#bbdefb' : '#ffffff'">Javascript</v-btn>
              <v-btn class="ma-1" elevation="0" @click="selectedProgrammingLanguage = 'python'" v-bind:color="selectedProgrammingLanguage === 'python' ? '#bbdefb' : '#ffffff'">Python</v-btn>
              <v-btn class="ma-1" elevation="0" @click="selectedProgrammingLanguage = 'ruby'" v-bind:color="selectedProgrammingLanguage === 'ruby' ? '#bbdefb' : '#ffffff'">Ruby</v-btn>
              <v-btn class="ma-1" elevation="0" @click="selectedProgrammingLanguage = 'php'" v-bind:color="selectedProgrammingLanguage === 'php' ? '#bbdefb' : '#ffffff'">PHP</v-btn>
              <v-btn class="ma-1" elevation="0" @click="selectedProgrammingLanguage = 'java'" v-bind:color="selectedProgrammingLanguage === 'java' ? '#bbdefb' : '#ffffff'">Java</v-btn>
              <v-btn class="ma-1" elevation="0" @click="selectedProgrammingLanguage = 'dotnet'" v-bind:color="selectedProgrammingLanguage === 'dotnet' ? '#bbdefb' : '#ffffff'" >.Net</v-btn>
              <v-btn class="ma-1" elevation="0" @click="selectedProgrammingLanguage = 'swift'" v-bind:color="selectedProgrammingLanguage === 'swift' ? '#bbdefb' : '#ffffff'">Swift</v-btn>
              <v-btn class="ma-1" elevation="0" @click="selectedProgrammingLanguage = 'objective_c'" v-bind:color="selectedProgrammingLanguage === 'objective_c' ? '#bbdefb' : '#ffffff'">Objective-C</v-btn>
            </v-col>
          </v-row>

    <v-row>
        <v-col cols="12">
          <v-col v-if="selectedProgrammingLanguage === 'curl'">
              <vue-code-highlight language="javascript">
                {{code_curl}}
              </vue-code-highlight>
            </v-col>
            <v-col v-if="selectedProgrammingLanguage === 'javascript'">
              <vue-code-highlight language="javascript">
                {{code_js}}
              </vue-code-highlight>
            </v-col>
            <v-col v-if="selectedProgrammingLanguage === 'python'">
              <vue-code-highlight language="javascript">
                {{code_python}}
              </vue-code-highlight>
            </v-col>
            <v-col v-if="selectedProgrammingLanguage === 'ruby'">
            <vue-code-highlight language="javascript">
              {{code_ruby}}
            </vue-code-highlight>
            </v-col>
            <v-col v-if="selectedProgrammingLanguage === 'php'">
            <vue-code-highlight language="javascript">
              {{code_php}}
            </vue-code-highlight>
            </v-col>
            <v-col v-if="selectedProgrammingLanguage === 'java'">
            <vue-code-highlight language="javascript">
              {{code_java}}
            </vue-code-highlight>
            </v-col>
            <v-col v-if="selectedProgrammingLanguage === 'dotnet'">
            <vue-code-highlight language="javascript">
              {{code_dotnet}}
            </vue-code-highlight>
            </v-col>
            <v-col v-if="selectedProgrammingLanguage === 'swift'">
            <vue-code-highlight language="javascript">
              {{code_swift}}
            </vue-code-highlight>
            </v-col>
            <v-col v-if="selectedProgrammingLanguage === 'objective_c'">
            <vue-code-highlight language="javascript">
              {{code_objective_c}}
            </vue-code-highlight>
            </v-col>

          </v-col>
      </v-row>

      </v-card>
      </v-col>
    </v-row>
    
  </v-container>
</template>

<script>
import { component as VueCodeHighlight } from 'vue-code-highlight';

  export default {
    name: 'SampleCode',

    components: {
      VueCodeHighlight
    },

    data(){
      return {
        selectedProgrammingLanguage: 'curl',
        code_curl: `
        curl -H 'API-KEY: YOUR_API_KEY_HERE'
           -F 'source_image_file=@source_image_path'
           -f https://api.simpleish.io/v1/remove_background
           -o output.png
        
        `,
        code_js: `// Requires "axios" and "form-data" to be installed (see https://www.npmjs.com/package/axios and https://www.npmjs.com/package/form-data)
var axios = require('axios');
var FormData = require('form-data');
var fs = require('fs');
var data = new FormData();
data.append('source_image_file', fs.createReadStream('YOUR_IMAGE_PATH'));

var config = {
  method: 'post',
  url: 'https://api.simpleish.io/v1/remove_background',
  headers: { 
    'Authorization': 'Bearer YOUR_API_KEY_HERE', 
    ...data.getHeaders()
  },
  data : data
};

axios(config)
.then(function (response) {
  console.log(JSON.stringify(response.data));
})
.catch(function (error) {
  console.log(error);
});`,
        code_python: `import requests

URL = "https://api.simpleish.io/v1/remove_background"
PATH = "YOUR_IMAGE_PATH"
API_KEY = "YOUR_API_KEY_HERE"

image_file = {'source_image_file': open(PATH, 'rb')}
headers = {'API-KEY': API_KEY}
response = requests.post(URL, files=image_file, headers=headers)

if response.status_code == requests.codes.ok:
    with open("no_bg_image.png", "wb") as out:
        out.write(response.content)
else:
    print("Error:", response.status_code, response.text)`,

    code_ruby: `require "uri"
require "net/http"

url = URI("https://api.simpleish.io/v1/remove_background")

http = Net::HTTP.new(url.host, url.port);
request = Net::HTTP::Post.new(url)
request["Authorization"] = "Bearer YOUR_API_KEY_HERE"
form_data = [['source_image_file', File.open('YOUR_IMAGE_PATH')]]
request.set_form form_data, 'multipart/form-data'
response = http.request(request)
puts response.read_body
`,

    code_php: `<?php

$curl = curl_init();

curl_setopt_array($curl, array(
  CURLOPT_URL => 'https://api.simpleish.io/v1/remove_background',
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_ENCODING => '',
  CURLOPT_MAXREDIRS => 10,
  CURLOPT_TIMEOUT => 0,
  CURLOPT_FOLLOWLOCATION => true,
  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
  CURLOPT_CUSTOMREQUEST => 'POST',
  CURLOPT_POSTFIELDS => array('source_image_file'=> new CURLFILE('YOUR_IMAGE_PATH')),
  CURLOPT_HTTPHEADER => array(
    'Authorization: Bearer YOUR_API_KEY_HERE'
  ),
));

$response = curl_exec($curl);

curl_close($curl);
echo $response;
`,

      code_java: `OkHttpClient client = new OkHttpClient().newBuilder()
  .build();
MediaType mediaType = MediaType.parse("text/plain");
RequestBody body = new MultipartBody.Builder().setType(MultipartBody.FORM)
  .addFormDataPart("source_image_file","input_image.jpeg",
    RequestBody.create(MediaType.parse("application/octet-stream"),
    new File("YOUR_IMAGE_PATH")))
  .build();
Request request = new Request.Builder()
  .url("https://api.simpleish.io/v1/remove_background")
  .method("POST", body)
  .addHeader("Authorization", "Bearer YOUR_API_KEY_HERE")
  .build();
Response response = client.newCall(request).execute();
`,

    code_dotnet: `var client = new RestClient("https://api.simpleish.io/v1/remove_background");
client.Timeout = -1;
var request = new RestRequest(Method.POST);
request.AddHeader("Authorization", "Bearer YOUR_API_KEY_HERE");
request.AddFile("source_image_file", "YOUR_IMAGE_PATH");
IRestResponse response = client.Execute(request);
Console.WriteLine(response.Content);
`,

code_swift: `
import Foundation
#if canImport(FoundationNetworking)
import FoundationNetworking
#endif

var semaphore = DispatchSemaphore (value: 0)

let parameters = [
  [
    "key": "source_image_file",
    "src": "YOUR_IMAGE_PATH",
    "type": "file"
  ]] as [[String : Any]]

let boundary = "Boundary-(UUID().uuidString)"
var body = ""
var error: Error? = nil
for param in parameters {
  if param["disabled"] == nil {
    let paramName = param["key"]!
    body += "--(boundary)\r\n"
    body += "Content-Disposition:form-data; name="(paramName)""
    if param["contentType"] != nil {
      body += "\r\nContent-Type: (param["contentType"] as! String)"
    }
    let paramType = param["type"] as! String
    if paramType == "text" {
      let paramValue = param["value"] as! String
      body += "\r\n\r\n(paramValue)\r\n"
    } else {
      let paramSrc = param["src"] as! String
      let fileData = try NSData(contentsOfFile:paramSrc, options:[]) as Data
      let fileContent = String(data: fileData, encoding: .utf8)!
      body += "; filename="(paramSrc)"\r\n"
        + "Content-Type: "content-type header"\r\n\r\n(fileContent)\r\n"
    }
  }
}
body += "--(boundary)--\r\n";
let postData = body.data(using: .utf8)

var request = URLRequest(url: URL(string: "https://api.simpleish.io/v1/remove_background")!,timeoutInterval: Double.infinity)
request.addValue("Bearer YOUR_API_KEY_HERE", forHTTPHeaderField: "Authorization")
request.addValue("multipart/form-data; boundary=(boundary)", forHTTPHeaderField: "Content-Type")

request.httpMethod = "POST"
request.httpBody = postData

let task = URLSession.shared.dataTask(with: request) { data, response, error in 
  guard let data = data else {
    print(String(describing: error))
    semaphore.signal()
    return
  }
  print(String(data: data, encoding: .utf8)!)
  semaphore.signal()
}

task.resume()
semaphore.wait()
`,

    code_objective_c: `
#import <Foundation/Foundation.h>

dispatch_semaphore_t sema = dispatch_semaphore_create(0);

NSMutableURLRequest *request = [NSMutableURLRequest requestWithURL:[NSURL URLWithString:@"https://api.simpleish.io/v1/remove_background"]
  cachePolicy:NSURLRequestUseProtocolCachePolicy
  timeoutInterval:10.0];
NSDictionary *headers = @{
  @"Authorization": @"Bearer YOUR_API_KEY_HERE"
};

[request setAllHTTPHeaderFields:headers];
NSArray *parameters = @[
  @{ @"name": @"source_image_file", @"fileName": @"YOUR_IMAGE_PATH" } 
];

NSString *boundary = @"----WebKitFormBoundary7MA4YWxkTrZu0gW";
NSError *error;
NSMutableString *body = [NSMutableString string];

for (NSDictionary *param in parameters) {
  [body appendFormat:@"--%@\r\n", boundary];
  if (param[@"fileName"]) {
    [body appendFormat:@"Content-Disposition:form-data; name="%@"; filename="%@"\r\n", param[@"name"], param[@"fileName"]];
    [body appendFormat:@"Content-Type: %@\r\n\r\n", param[@"contentType"]];
    [body appendFormat:@"%@", [NSString stringWithContentsOfFile:param[@"fileName"] encoding:NSUTF8StringEncoding error:&error]];
    if (error) {
      NSLog(@"%@", error);
    }
  } else {
    [body appendFormat:@"Content-Disposition:form-data; name="%@"\r\n\r\n", param[@"name"]];
    [body appendFormat:@"%@", param[@"value"]];
  }
}
[body appendFormat:@"\r\n--%@--\r\n", boundary];
NSData *postData = [body dataUsingEncoding:NSUTF8StringEncoding];
[request setHTTPBody:postData];

[request setHTTPMethod:@"POST"];

NSURLSession *session = [NSURLSession sharedSession];
NSURLSessionDataTask *dataTask = [session dataTaskWithRequest:request
completionHandler:^(NSData *data, NSURLResponse *response, NSError *error) {
  if (error) {
    NSLog(@"%@", error);
    dispatch_semaphore_signal(sema);
  } else {
    NSHTTPURLResponse *httpResponse = (NSHTTPURLResponse *) response;
    NSError *parseError = nil;
    NSDictionary *responseDictionary = [NSJSONSerialization JSONObjectWithData:data options:0 error:&parseError];
    NSLog(@"%@",responseDictionary);
    dispatch_semaphore_signal(sema);
  }
}];
[dataTask resume];
dispatch_semaphore_wait(sema, DISPATCH_TIME_FOREVER);
`

  }
},





    created(){
      this.base = 'http://localhost:8000';
      
      this.init();
    },

    methods: {
      init(){
      },
      
    }
  }
</script>